import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sbpro-dashboard-head-compact',
    templateUrl: './dashboard-head-compact.component.html',
    styleUrls: ['dashboard-head-compact.component.scss'],
})
export class DashboardHeadCompactComponent {
    @Input() icon!: string;
    @Input() title!: string;
    @Input() light = true;

    darkClasses = ['page-header-dark', 'bg-gradient-primary-to-secondary'];
    lightClasses = ['page-header-light', 'bg-white', 'shadow'];

    constructor() {}
}
